// src/crm/hooks/useUnmatchedEmails.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../../lib/api'
import type { UnmatchedEmail } from '../../lib/types'

type UnmatchedEmailsResponse = {
  unmatchedEmails: UnmatchedEmail[]
}

type AssignPayload = {
  unmatchedId: string
  creatorId: string
}

export function useUnmatchedEmails() {
  return useQuery<UnmatchedEmail[]>({
    queryKey: ['unmatched-emails'],
    queryFn: () =>
      api
        .get<UnmatchedEmailsResponse>('/api/unmatched-emails')
        .then((r) => r.unmatchedEmails),
  })
}

export function useAssignUnmatchedEmail() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ unmatchedId, creatorId }: AssignPayload) =>
      api.post<{ ok: boolean; messageId: string; conversationId: string }>(
        `/api/unmatched-emails/${unmatchedId}/assign`,
        { creatorId },
      ),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['unmatched-emails'] })
      void queryClient.invalidateQueries({ queryKey: ['conversations'] })
    },
  })
}
